import { useEffect, useState, useCallback } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Field } from "@/components/common";
import { adminApi, errMsg, fmtDate } from "@/lib/api";
import { toast } from "sonner";

const EMPTY = { code: "", description: "", trial_days: 15, max_uses: 0, expires_at: "", active: true };

export function CouponsTab() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState(EMPTY);
  const load = useCallback(() => adminApi.get("/coupons").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const create = async (e) => {
    e.preventDefault();
    try {
      await adminApi.post("/coupons", { ...f, trial_days: Number(f.trial_days), max_uses: Number(f.max_uses) || 0 });
      toast.success("Cupom criado");
      setF(EMPTY); load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const toggle = async (c) => {
    try { await adminApi.put(`/coupons/${c.id}`, { ...c, active: !c.active }); load(); } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Excluir o cupom ${c.code}?`)) return;
    await adminApi.delete(`/coupons/${c.id}`); load();
  };
  return (
    <div className="space-y-4">
      <form onSubmit={create} className="card-surface p-5 grid sm:grid-cols-3 lg:grid-cols-6 gap-3 items-end" data-testid="coupon-form">
        <Field label="Código"><Input value={f.code} onChange={(e) => setF((x) => ({ ...x, code: e.target.value.toUpperCase() }))} required data-testid="coupon-code-input" /></Field>
        <Field label="Descrição" className="lg:col-span-2"><Input value={f.description} onChange={set("description")} data-testid="coupon-description-input" /></Field>
        <Field label="Dias extras de teste"><Input type="number" min={1} value={f.trial_days} onChange={set("trial_days")} data-testid="coupon-days-input" /></Field>
        <Field label="Limite de usos" hint="0 = ilimitado"><Input type="number" min={0} value={f.max_uses} onChange={set("max_uses")} data-testid="coupon-max-uses-input" /></Field>
        <Field label="Válido até"><Input type="date" value={f.expires_at} onChange={set("expires_at")} data-testid="coupon-expires-input" /></Field>
        <Button type="submit" className="lg:col-start-6" data-testid="coupon-create-btn"><Plus className="h-4 w-4 mr-1" />Criar cupom</Button>
      </form>
      <div className="card-surface overflow-x-auto">
        <Table data-testid="coupons-table">
          <TableHeader><TableRow><TableHead>Código</TableHead><TableHead>Descrição</TableHead><TableHead>Dias extras</TableHead><TableHead>Usos</TableHead><TableHead>Validade</TableHead><TableHead>Ativo</TableHead><TableHead /></TableRow></TableHeader>
          <TableBody>
            {items.map((c) => (
              <TableRow key={c.id} data-testid={`coupon-row-${c.code}`}>
                <TableCell className="font-mono font-semibold">{c.code}</TableCell>
                <TableCell>{c.description}</TableCell>
                <TableCell>+{c.trial_days} dias</TableCell>
                <TableCell>{c.uses}{c.max_uses ? ` / ${c.max_uses}` : ""}</TableCell>
                <TableCell>{c.expires_at ? fmtDate(c.expires_at + "T12:00") : "Sem validade"}</TableCell>
                <TableCell><Switch checked={c.active} onCheckedChange={() => toggle(c)} data-testid={`coupon-active-${c.code}`} /></TableCell>
                <TableCell><Button size="icon" variant="ghost" onClick={() => remove(c)} data-testid={`coupon-delete-${c.code}`}><Trash2 className="h-4 w-4" /></Button></TableCell>
              </TableRow>
            ))}
            {!items.length && <TableRow><TableCell colSpan={7} className="py-8 text-center text-muted-foreground">Nenhum cupom criado. Os cupons dão dias extras de teste no cadastro.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
